import React from 'react';

const FlexiblePagePortalContext = React.createContext<HTMLElement | null>(null);

type FlexiblePagePortalProviderProps = {
  container: HTMLElement | null;
  children: React.ReactNode;
};

export function FlexiblePagePortalProvider({ container, children }: FlexiblePagePortalProviderProps) {
  return <FlexiblePagePortalContext.Provider value={container}>{children}</FlexiblePagePortalContext.Provider>;
}

export function useFlexiblePagePortalContainer(): HTMLElement | null {
  return React.useContext(FlexiblePagePortalContext);
}
